import { Container } from "reactstrap";
import { Breadcrumbs, ToastContainer } from "../../components/Common";
import DashboardPage from "./page";

const DashboardPageWrapper = () => {
    //meta title
    document.title = "Dashboard";

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title="Dashboard"
                />
            </Container>
            <div className="p-2">
                <DashboardPage />
            </div>
            <ToastContainer />
        </div>
    );
};

export default DashboardPageWrapper;
